/* eslint-disable react/prop-types */ // TODO: add props
import { Icon } from 'edrolo-style-guide';
import ChunkBookmarkPopoverTrigger from '../ChunkBookmarkPopoverTrigger';
import s from './ChunkBookmark.scss';

const ChunkBookmark = ({
  bookmark,
  chunkId,
  enabled,
  fullButton,
  disabled = false,
}) => {
  const text = bookmark ? 'Bookmarked' : 'Bookmark chunk';

  const inner = fullButton ? (
    <button
      className={s.chunkBookmark}
      data-test="bookmark-button"
      disabled={disabled}
    >
      <Icon name="bookmark" />
      {text}
    </button>
  ) : (
    <span className={s.chunkBookmark} data-test="bookmark-link" />
  );

  return (
    <>
      {enabled ? (
        <ChunkBookmarkPopoverTrigger
          chunkId={chunkId}
          bookmark={bookmark}
          placement="right"
          narrowPlacement="left"
        >
          {inner}
        </ChunkBookmarkPopoverTrigger>
      ) : (
        inner
      )}
    </>
  );
};

ChunkBookmark.defaultProps = {
  fullButton: false,
  enabled: true,
};

export default ChunkBookmark;
